import React from "react";
import "./style/Author.css";
import Avatar from "@material-ui/core/Avatar";

function Author({ src, name }) {
  return (
    <div className="author">
      <Avatar src={src} />
      <p>{name}</p>
    </div>
  );
}

export default Author;
